export default {
    adjustments: {
        title: 'Adjustments',
        reset: 'Reset',
        light: {
            title: 'Light',
            brightness: 'Brightness',
            contrast: 'Contrast',
            shadows: 'Shadows',
        },
        color: {
            title: 'Color',
            saturation: 'Saturation',
            temperature: 'Temperature',
            blacks: 'Blacks',
            whites: 'Whites',
        },
        detail: {
            title: 'Detail',
            clarity: 'Clarity',
            sharpness: 'Sharpness',
            blur: 'Blur',
        },
    },
};
